import { types as actionTypes } from '../actions/feed'
import initialState from '../initialState/feed'

// eslint-disable-next-line default-param-last
export default function (state = initialState, action) {
  switch (action.type) {
    case actionTypes.SET_FEED_MODE: {
      const { isFeedMode } = action.payload
      return { ...state, isFeedMode }
    }

    case actionTypes.SET_FEED_LOADING: {
      const { isLoading } = action.payload
      return { ...state, isLoading }
    }

    case actionTypes.SET_FEED_QUERY: {
      const { query } = action.payload
      return { ...state, query }
    }

    case actionTypes.SET_FEED_PAGE: {
      const { items, page, totalCount } = action.payload

      // pagination shows one page at a time: the visible list is replaced
      return {
        ...state,
        items,
        page,
        totalCount,
      }
    }

    default:
      return state
  }
}
